import { BananaSpine } from './../room/banana/BananaSpine';
import { GameVars } from './../../GameVars';
import { GameConstants } from './../../GameConstants';
import { Button } from '../../utils/Button';
import { HiLoManager } from '../../managers/HiLoManager';
import { AudioManager } from '../../managers/AudioManager';
import { Translation } from '../../Translation';

export class CompletedLayer extends Phaser.GameObjects.Container {

    public titleLabel: Phaser.GameObjects.Image;
    public bananaSpine: BananaSpine;
    private replayButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        let midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.scaleX = GameVars.scaleX;
        this.add(midContainer);

        this.titleLabel = new Phaser.GameObjects.Image(this.scene, 0, -65, "texture_atlas_1");
        this.titleLabel.setOrigin(.5);
        midContainer.add(this.titleLabel);

        this.bananaSpine = new BananaSpine(this.scene);
        this.bananaSpine.setPosition(-100, -30);
        this.bananaSpine.setScale(.8);
        midContainer.add(this.bananaSpine);

        this.replayButton = new Button(this.scene, 0, 250, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true, true);
        this.replayButton.onDown(this.onClickReplayButton, this);
        midContainer.add(this.replayButton);

        const replayLabel = new Phaser.GameObjects.Text(this.scene, this.replayButton.x, this.replayButton.y, Translation.getText("PLAY AGAIN"), { fontFamily: "Oswald-Medium", fontSize: "26px", color: "#6D3624", align: "center" });
        replayLabel.setOrigin(.5);
        midContainer.add(replayLabel);

        this.visible = false;
    }

    public show(gameOver: boolean): void {

        this.visible = true;
        this.alpha = 0;

        this.scene.time.addEvent({
            delay: 1000, callback: () => {
                if (gameOver) {
                    this.bananaSpine.setAvatarState("you-lose-start");
                } else {
                    this.bananaSpine.setAvatarState("victory1");
                }
                this.scene.tweens.add({
                    targets: this,
                    alpha: 1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500
                });
            }, callbackScope: this
        });

        if (gameOver) {
            this.titleLabel.setFrame("game_over_hilo.png");
            this.titleLabel.y = -45;
        } else {
            this.titleLabel.setFrame("you_win_hilo.png");
            this.titleLabel.y = -65;
        }

        AudioManager.volumeMusic(.1);
    }

    private onClickReplayButton(): void {

        AudioManager.playSound("btn_click");

        AudioManager.volumeMusic(.5);

        HiLoManager.onReplay();
    }
}
